<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>椰糕🥥🍰</h3>
          <p>一个为9779s创建的专属空间，记录每一个美好瞬间。</p>
          <p class="footer-heart">
            <i class="fas fa-heart"></i>
            <span>糕糕在宝贝心中。永远爱我哟 -^3^-</span><br />
            <i class="fas fa-heart"></i>
            <span>小椰子，我在。ᨐᵉᵒʷ </span>
          </p>
        </div>

        <div class="footer-section">
          <h3>快速导航</h3>
          <ul class="footer-links">
            <li v-for="(section, index) in sections.slice(0, 6)" :key="index">
              <a href="javascript:void(0);" @click="navigateTo(section.path)">{{
                section.name
              }}</a>
            </li>
          </ul>
        </div>

        <div class="footer-section">
          <h3>关注我们</h3>
          <ul class="footer-links">
            <li>
              <a
                href="https://weibo.com/p/1008086fb2bc90dcea6c76647ce3e5ac13c50e/super_index"
                target="_blank"
                ><i class="fab fa-weibo"></i> 微博超话</a
              >
            </li>
            <li>
              <a href="https://weibo.com/6864683692/5249202654281927"
                ><i class="fab fa-qq"></i> 加入粉丝群</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="copyright">
        <p>© 2025 豆瓣番茄 | 本网站为粉丝创作，与其他无关 | 设计制作:番茄</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      sections: [
        { path: "/", name: "首页" },
        { path: "/intro", name: "个人简介" },
        { path: "/material", name: "物料补档" },
        { path: "/design", name: "设计爱情" },
        { path: "/data", name: "数据记录" },
        { path: "/literature", name: "文学创作" },
      ],
    };
  },
  methods: {
    navigateTo(path) {
      // 如果当前已经在目标路由，先滚动到顶部再刷新
      if (this.$route.path === path) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        // 否则进行路由跳转（路由配置会自动滚动到顶部）
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped>
/* 页脚特定样式 */
.footer-heart {
  margin-top: 10px;
}

.footer-heart i {
  color: #ff6b9d;
  margin-right: 10px;
}

.footer-links i {
  margin-right: 8px;
}
</style>
